import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";

export const postNewDebtsStudent = async (body: any): Promise<any> => {
    try {
        const data = await postApi(`/debts`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const pacthNewDebtsStudent = async (id: number, body: any): Promise<any> => {
    try {
        const data = await patchApi(`/debts/${id}/cancel`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const getAllDebtsStudent = async (params?: any): Promise<any[]> => {
    try {
        const data = await getApi('/debts', params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}   

export const deletedDebtsSudent = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/debts/${id}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}